import { Alert, AlertIcon, Text, Heading, Stack } from '@chakra-ui/react';

type Props = {
  status?: 'success' | 'error' | 'warning' | 'info';
  mt?: number;
  mb?: number;
  text: string;
  subtitle?: string | null;
};

export const AlertWithIcon = (props: Props) => {
  const { status = 'info', mt = 0, mb = 0, text, subtitle = null } = props;

  return (
    <Alert
      status={status}
      mt={mt}
      mb={mb}
      pl={{ base: 1, md: 2 }}
      pr={{ base: 1, md: 2 }}
    >
      {subtitle ? (
        <Stack
          direction={'column'}
          width={'100%'}
          textAlign={{ base: 'left', md: 'center' }}
        >
          <Stack direction={'row'} alignSelf={{ base: 'left', md: 'center' }}>
            <AlertIcon />
            <Heading size={'sm'} ml={-3}>
              {subtitle}
            </Heading>
          </Stack>
          {text.split('\\n').map((line, index) => (
            <Text fontSize={'sm'}>
              {line}
              <br />
            </Text>
          ))}
        </Stack>
      ) : (
        <>
          <AlertIcon />
          {/* 2024.09 COMTEC kawaji MOD START */}
          {/* {text} */}
          <Stack direction={'column'} spacing={0}>
            {text.split('\\n').map((line, index) => (
              <Text fontSize={'md'} key={index}>
                {line}
                <br />
              </Text>
            ))}
          </Stack>
          {/* 2024.09 COMTEC kawaji MOD END */}
        </>
      )}
    </Alert>
  );
};
